import * as yup from "yup";

const sendMessageSchema = yup.object().shape({
  body: yup.string().required("Message must not be blank")
});

export default sendMessageSchema;